import { AreaType } from './types'

interface AreaProps {
  area: AreaType
}

export default function Area({ area }: AreaProps) {
  return (
    <div>
      <p className="my-5">
        <strong className="block font-medium mb-1">Name:</strong>
        {area.name?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Community:</strong>
        {area.community_id?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Code:</strong>
        {area.code?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Metadata:</strong>
        {area.metadata?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Status:</strong>
        {area.status?.toString()}
      </p>
    </div>
  )
}
